import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LanguageSelector from "../languageSelector";
import translations from "../../assets/locals/translations";
import { red } from "@mui/material/colors";

const BreadCrumb = () => {
  const currentLanguage = useSelector((state) => state.language.language);
  const [isHovered, setIsHovered] = useState(false);
  const [language, setLanguage] = useState("en");

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleDownloadIos = () => {
    window.alert("App Not Found");
  };

  const handleDownloadAndroid = () => {
    console.log("Downloading Android.....");
    const androidApkUrl = `${process.env.REACT_APP_NODE_URL}/api/download`;
    const anchor = document.createElement("a");
    anchor.style.display = "none";
    anchor.href = androidApkUrl;
    anchor.download = "android-app.apk";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const location = useLocation();
  const crumbs = location.pathname.split("/").filter((crumb) => crumb !== "");
  const isDashboardPage = location.pathname === "/home/dashboard";

  return (
    <div className="container-fluid">
      <div className="row shadow mb-1 bg-white">
        <div className="col-md-9 mt-1">
          <div className="mb-1">
            <div className="headerListUi">
              <Breadcrumbs aria-label="breadcrumb">
                {crumbs.map((crumb, index, array) => {
                  const currentLink = `/${array.slice(0, index + 1).join("/")}`;
                  const isLastCrumb = index === array.length - 1;
                  const isFirstCrumb = index === 0;

                  // helper: convert a phrase like "chassis_print" -> "chassisPrint" -> try keys
                  const toCamel = (str) => {
                    return str
                      .split(/[_\-\s]+/)
                      .map((word, i) =>
                        i === 0
                          ? word.toLowerCase()
                          : word.charAt(0).toUpperCase() +
                            word.slice(1).toLowerCase(),
                      )
                      .join("");
                  };

                  const lookupTranslation = (raw) => {
                    // Known special mappings for step route segments
                    const special = {
                      chassis_print: "chassisPrintTitle",
                      documents: "documentsTitle",
                      parsing_complete: "parsingPendingTitle",
                      plate_order: "plateOrderTitle",
                      rc_fitment: "rcFitmentTitle",
                      rc_dispatch: "rcDispatchTitle",
                    };

                    if (special[raw])
                      return translations[currentLanguage][special[raw]];

                    // Try several candidate keys
                    const normalized = raw
                      .replace(/--/g, " ")
                      .replace(/-/g, " ");
                    const candidates = [
                      raw,
                      normalized,
                      raw.replace(/_/g, " "),
                      toCamel(raw),
                      toCamel(raw) + "Title",
                      toCamel(normalized),
                      toCamel(normalized) + "Title",
                    ];

                    for (const c of candidates) {
                      if (!c) continue;
                      const v = translations[currentLanguage][c];
                      if (v) return v;
                    }

                    return null;
                  };

                  const resolved =
                    lookupTranslation(crumb) || crumb.replace(/--/g, " ");

                  return (
                    <Typography key={index} color="textPrimary">
                      {isFirstCrumb ? (
                        <Link className="crumb-link">{resolved}</Link>
                      ) : (
                        <Link
                          className="crumb-link"
                          to={currentLink}
                          color={isLastCrumb ? "textPrimary" : "inherit"}
                        >
                          {resolved}
                        </Link>
                      )}
                      {index === array.length - 1 && !isLastCrumb && (
                        <ExpandMoreIcon fontSize="small" />
                      )}
                    </Typography>
                  );
                })}
              </Breadcrumbs>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 mt-1 d-flex align-items-center"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div
            className="download-container"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "-2px",
            }}
          >
            {isDashboardPage && (
              <div
                className="download-bar"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                {isHovered ? (
                  <div className="download-menu-container">
                    <button
                      className="download-button"
                      onClick={handleDownloadIos}
                    >
                      {translations[currentLanguage].ios}
                    </button>
                    <button
                      className="download-button"
                      onClick={handleDownloadAndroid}
                    >
                      {translations[currentLanguage].android}
                    </button>
                  </div>
                ) : (
                  <p className="mt-3">
                    {translations[currentLanguage].download}
                  </p>
                )}
              </div>
            )}
          </div>
          <LanguageSelector
            onChangeLanguage={(e) => setLanguage(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default BreadCrumb;
